export default {"tickBoxWrapper":"Unk1h","labelWrapper":"dXoKx","checkbox":"_1Uu-8","checked":"ualCf","labelText":"OaLit","checkmark":"r6CiO","error":"fEkxU"};